import { ClientInfo } from "../Utility/Utility";

// Cart is switched on per client by this key in Client Master (clientConfigurations),
// the same key and list the cart API checks.
const CART_ENABLED_CONFIG_KEY = "iscartenabled";
const TRUTHY_VALUES = ["1", "true"];

/* isCartEnabled: the client has the cart turned on.
   isCartConfigLoaded: the client data has arrived, so a false isCartEnabled
   really means "off" and not "not loaded yet". */
const useCartEnabled = () => {
  const clientData = ClientInfo()?.clientData;

  const configValue = (clientData?.clientConfigurations || []).find(
    (item) => String(item?.configKey ?? "").trim().toLowerCase() === CART_ENABLED_CONFIG_KEY
  )?.configValue;

  return {
    isCartEnabled:
      configValue === true ||
      TRUTHY_VALUES.includes(String(configValue ?? "").trim().toLowerCase()),
    isCartConfigLoaded: Boolean(clientData),
  };
};

export default useCartEnabled;
